import { Component, OnInit } from '@angular/core';
import { GraphqlService } from 'src/app/services/graphql.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';


@Component({
  selector: 'app-marketing-dashboard',
  templateUrl: './marketing-dashboard.component.html',
  styleUrls: ['./marketing-dashboard.component.css']
})
export class MarketingDashboardComponent implements OnInit {

  userSourceData: any;
  totalPackagesData: any;
  totalCount: number = 0;
  consultationStatusData: any;
  pieChartData: any; 
  pieChartOptions: any; 
  totalStatusCount: number =0;
  totalPackagesCount: number =0;
  is_primary_provider: boolean = false;

  constructor(
    private readonly graphqlService: GraphqlService,
    private readonly providerstateService: ProviderStateService
  ) { }

  async ngOnInit() {
    this.is_primary_provider = this.providerstateService.getIsPrimaryProvider();
    await this.getUsersBySource();
    await this.getPackagesCount();
    await this.getConsultationStatus();
  }

  async getUsersBySource() {
    this.graphqlService.getMarketingCounts().subscribe(
      (result) => {
     
        const sourceData =
          result.data['aggregateUsers'];

        const sourceCountsMap = new Map<string | null, number>();

        sourceData.forEach((entry) => {
          const sourceName =
            entry.user_source?.source;
          const userCount = entry.COUNT;

          if (sourceCountsMap.has(sourceName)) {
            sourceCountsMap.set(
              sourceName,
              sourceCountsMap.get(sourceName)! + userCount
            );
          } else {
            sourceCountsMap.set(sourceName, userCount);
          }
        });

        const Sources = Array.from(sourceCountsMap.keys());
        const userCounts = Array.from(sourceCountsMap.values());

        this.totalCount = userCounts.reduce(
          (total, count) => total + count,
          0
        );

        this.userSourceData = {
          labels: Sources,
          datasets: [
            {
              label: 'User Count by Source',
              data: userCounts,
              backgroundColor: [
                '#ADD8E6',
                '#eedd82',
                '#FFA07A',
                '#B19CD9',
                '#2E78D2',
                '#b5651d',
                '#F08080',
                '#90EE90',
                '#FFB6C1',
                '#E6E6FA'
              ]
            }
          ]
        };
   

     
      },
      (error) => {
        console.error(
          'There was an error fetching the count from the API',
          error
        );
      }
    );
  }

  async getPackagesCount() {
    this.graphqlService.getMarketingCounts().subscribe(
      (result) => {
       
        const packagesData =
          result.data['aggregateUserPackages'];

        const packageDataMap = new Map<string, Map<string | null, number>>();

        packagesData.forEach((entry) => {
          const packageName = entry.package_type?.package_name;
          const countryName = entry.package_type?.country?.country_name;
          const packageCount = entry.COUNT;

          if (!packageDataMap.has(packageName)) {
            packageDataMap.set(packageName, new Map<string | null, number>());
          }

          const countryMap = packageDataMap.get(packageName)!;

          if (countryMap.has(countryName)) {
            countryMap.set(
              countryName!,
              countryMap.get(countryName)! + packageCount
            );
          } else {
            countryMap.set(countryName!, packageCount);
          }
          this.totalPackagesCount +=packageCount;
        });

        const packageEntries = Array.from(packageDataMap.entries());

        const packageColors = [
          '#ADD8E6',
          '#eedd82',
          '#FFA07A',
          '#B19CD9',
          '#2E78D2',
          '#b5651d',
          '#F08080',
          '#90EE90',
          '#FFB6C1',
          '#E6E6FA'
        ];

        const datasets = packageEntries.map(([packageName, countryMap], index) => {
          const countryNames = Array.from(countryMap.keys());
          const packageCounts = Array.from(countryMap.values());
          const backgroundColor = packageColors[index % packageColors.length];

          const labels = countryNames.map(country => `${country} - ${packageName}`);

          return {
            label: packageName,
            data: packageCounts,
            backgroundColor: backgroundColor,
            labels: labels
          };
        });

        const countryLabels: string[] = [];
        packageDataMap.forEach((countryMap) => {
          countryMap.forEach((_, countryName) => {
            if (countryName) countryLabels.push(countryName);
          });
        });

        this.totalPackagesData = {
          labels: Array.from(new Set(countryLabels)),
          datasets: datasets,
        };

        
      },
      (error) => {
        console.error(
          'There was an error fetching the count from the API',
          error
        );
      }
    );
  }

  async getConsultationStatus() {
    this.graphqlService.getMarketingCounts().subscribe(
      (result) => {
        const statusData = result.data['aggregateConsultation'];

        const labels = statusData.map(item => item.consultation_status);
        const counts = statusData.map(item => item.COUNT);

        this.totalStatusCount = counts.reduce((total, count) => total + count, 0);

        this.consultationStatusData = {
          labels: labels,
          datasets: [
            {
              data: counts,
              backgroundColor: [
                'rgba(255, 99, 132, 0.6)',
                'rgba(54, 162, 235, 0.6)',
                'rgba(255, 206, 86, 0.6)',
                'rgba(75, 192, 192, 0.6)',
                'rgba(153, 102, 255, 0.6)',
                'rgba(255, 159, 64, 0.6)'
              ]
            }
          ]
        };

        this.pieChartOptions = {
          title: {
            display: true,
            text: 'Consultation Status'
          }
        };
        
      },
      (error) => {
        console.error(
          'There was an error fetching the count from the API',
          error
        );
      }
    );
  }


}
